module.exports = __webpack_public_path__ + "img/program-3-2.719a54ce.png";